const genericMainText = {
	name: 'Main Text',
	type: 'string',
	default: 'Your copy here',
	options: null,
	required: true,
	userData: 'default1',
	validation: null,
};
const genericSubtext = {
	name: 'Subtext',
	type: 'string',
	default: 'Your copy here',
	options: null,
	required: true,
	userData: 'default2',
	validation: null,
};
const genericColor1 = {
	name: 'Color 1',
	type: 'color',
	default: '#FEF75D',
	options: null,
	required: false,
	userData: 'color4',
	validation: null,
};
const genericColor2 = {
	name: 'Color 2',
	type: 'color',
	default: '#53DFFD',
	options: null,
	required: false,
	userData: 'color5',
	validation: null,
};
const genericColor3 = {
	name: 'Color 3',
	type: 'color',
	default: '#9DFE74',
	options: null,
	required: false,
	userData: 'color2',
	validation: null,
};
const genericColor4 = {
	name: 'Color 4',
	type: 'color',
	default: '#FE62E0',
	options: null,
	required: false,
	userData: 'color1',
	validation: null,
};

export const lockedAssetFieldsOverlay = [
	genericMainText,
	genericSubtext,
	genericColor1,
	genericColor2,
	genericColor3,
	genericColor4,
];

export const lockedAssetFieldsMedia = [
	genericMainText,
	genericSubtext,
	genericColor1,
	genericColor2,
	genericColor3,
	genericColor4,
];
